import officeApi from '../../api/officeApi';
import { sha256 } from 'js-sha256';

const FIFTY_MINUTES_INT = 3000000;
export const THIRTY_MINUTES_INT = 1800000;

export const setLocalStorageWithExpiry = (key, value, ttl) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getLocalStorageWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export const removeLocalStorageKey = (key) => {
  localStorage.removeItem(key);
};

// given concerns with Microsoft/graph changing IDs special characters depending on platform, it is
// easiest to simply remove them as the length of the string is great enough that we will likely not
// run into and issues of duplicated keys. For context:
// https://docs.microsoft.com/en-us/graph/api/user-translateexchangeids?view=graph-rest-1.0&tabs=http#exchangeidformat-values
const formatKey = (key) => key.replace(/[^a-zA-Z0-9]/g, '');

const PLATFORMS_TO_USE_OFFICE_API = ['PC', 'Mac'];

export const isWindowsDesktop = () => (officeApi.getPlatform() === 'PC');

export const usingOfficeApi = () => PLATFORMS_TO_USE_OFFICE_API.includes(officeApi.getPlatform());

export const calculateAttachmentHash = (name, content) => {
  return sha256(content + name);
};

export const calculateAlternativeAttachmentHash = (name) => {
  return sha256(name);
};

export const handleDocrioAttachments = async (attachmentHashes) => {
  let draftId = await officeApi.saveEmail();
  draftId = formatKey(draftId);
  const docrioAttachments = getLocalStorageWithExpiry(draftId);

  // Reformat attachment ids to be consistent.
  const formattedAttachments = {};
  Object.keys(attachmentHashes).forEach((key) => {
    formattedAttachments[formatKey(key)] = attachmentHashes[key];
  });
  const cacheContent = docrioAttachments ? { ...docrioAttachments, ...formattedAttachments } : { ...formattedAttachments };
  setLocalStorageWithExpiry(draftId, cacheContent, FIFTY_MINUTES_INT);
};

export const getDocrioAttachments = async () => {
  let draftId = await officeApi.saveEmail();
  draftId = formatKey(draftId);
  const attachments = getLocalStorageWithExpiry(draftId);
  return attachments ?? {};
};
